import { red } from '@mui/material/colors';

const black = {
  50: '#212121',
  100: '#212121',
  200: '#212121',
  300: '#212121',
  400: '#212121',
  500: '#212121',
  600: '#212121',
  700: '#212121',
  800: '#212121',
  900: '#212121',
  A100: '#212121',
  A200: '#212121',
  A400: '#212121',
  A700: '#212121'
};

export const Theme = {
  palette: {
    mode: 'light',
    primary: red,
    secondary: black,
    action: {
      disabled: 'rgba(126,126,126,1)',
      disabledBackground: 'rgba(246,246,246,1)'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontWeight: 'bold'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          backgroundColor: '#ffffff'
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff'
        }
      }
    },
    MuiCardMedia: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#ffffff'
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          borderTop: 'none',
          borderBottom: 'none',
          paddingRight: '40px !important',
          paddingLeft: '40px !important',
          paddingTop: '10px !important'
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          paddingBottom: '5px'
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          paddingRight: '40px !important',
          paddingLeft: '40px !important',
          paddingBottom: '40px !important'
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginBottom: '5px'
        }
      }
    },

    '.MuiAutocomplete.MuiOutlinedInput': {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          borderRadius: '20px'
        }
      }
    }
  }
};
